import { TableColumn } from "../table/table.model";

export const columnsSimples :TableColumn[] = [
  {
    name: '' ,
    key: 'selected' ,
    type: 'check',
    options: {
      width: 4,
      widthUnit: 'proportional',
      position: 'center'
    }
  },
  {
    name: '' ,
    key: 'name' ,
    type : 'value',
    options: {
      width: 75,
      widthUnit: 'proportional',
      position: 'start'
    }
  }
];

export const columnsWithNumber: TableColumn[] = [
  columnsSimples[0] , {
    name: '' ,
    key: 'grau' ,
    type : 'value',
    options: {
      width: 15,
      widthUnit: 'proportional',
      position: 'start'
    }
  },
  columnsSimples[1] ]
